<template>
    <div class="mproduct">      
                <mpSlide1></mpSlide1>       
                <mpSlide2></mpSlide2>       
                <mpSlide3></mpSlide3>         
                <mpSlide4></mpSlide4>       
                <mpSlide5></mpSlide5>
    </div>
</template>
<script>
import mpSlide1 from "./mpSlide1"
import mpSlide2 from "./mpSlide2"
import mpSlide3 from "./mpSlide3"
import mpSlide4 from "./mpSlide4"
import mpSlide5 from "./mpSlide5"
    export default {
        name: "MProduct",
        components :{
            mpSlide1,
            mpSlide2,
            mpSlide3,
            mpSlide4,
            mpSlide5
        },
          data() {
    return {
      swiperOptions: {
        initialSlide: 0,
        direction: "vertical",
      }
    };
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.$swiper;
    }
  },
  mounted() {
    console.log("Current Swiper instance object", this.swiper);
    // this.swiper.slideTo(3, 1000, false)
  }
    }
</script>
<style lang="scss" scoped>
.mproduct {
  width: 100%;
  height: 100%;
  position: relative;
}
</style>